import React from 'react'
import { Form, Row, Col } from 'react-bootstrap'
import type { Article } from '../types'

type Props = {
  value: string
  candidates: Article[]
  onChange: React.ChangeEventHandler<HTMLElement>
  onBlur: React.FocusEventHandler<HTMLElement>
}

export const InsertPositionField = ({ value, candidates, onChange, onBlur }: Props) => {
  return (
    <Row className='mb-2'>
      <Form.Group as={Col}>
        <Form.Label column>挿入位置</Form.Label>
        <Col>
          <Form.Select name='insertBeforeArticleId' size='sm' value={value} onChange={onChange} onBlur={onBlur}>
            <option value=''>末尾に追加</option>
            {candidates.map((a) => (
              <option key={`insert-before-option-${a.id}`} value={a.id}>
                {`${a.name || a.filename || ''} の前に挿入`}
              </option>
            ))}
          </Form.Select>
        </Col>
      </Form.Group>
    </Row>
  )
}
